var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupervisorSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.106,
    height: 35.774,
    viewBox: "0 0 51.106 35.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-supervisor-account",
    "data-name": "Icon material-supervisor-account",
    d: "M40.052,25.387A6.388,6.388,0,1,0,33.664,19,6.369,6.369,0,0,0,40.052,25.387ZM20.887,22.832a7.666,7.666,0,1,0-7.666-7.666A7.634,7.634,0,0,0,20.887,22.832ZM40.052,30.5C35.376,30.5,26,32.849,26,37.525v5.749H54.106V37.525C54.106,32.849,44.728,30.5,40.052,30.5ZM20.887,27.943C14.933,27.943,3,30.932,3,36.886v6.388H20.887V37.525c0-2.172.843-5.979,6.056-8.867A31.387,31.387,0,0,0,20.887,27.943Z",
    transform: "translate(-3 -7.5)",
    fill: "#afb0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorSelection);
export default __webpack_public_path__ + "static/media/SupervisorSelection.8ae55bc55f546b4bd5a896d72aa854da.svg";
export { ForwardRef as ReactComponent };